import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout, { Container } from "../components/layout";
import { apiurl } from "../config/config";
import {
  FaFileExcel,
} from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as XLSX from "xlsx";
import { motion } from "framer-motion";
import { IoMdClose } from "react-icons/io";
import { SuwasthiLoader } from "../components/loader";
import Pagination from "../components/pagination";

const PastJoining = () => {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [assignModal, setAssignModal] = useState(false);
  const [selectedApp, setSelectedApp] = useState(null);
  const [role, setRole] = useState("");
  const [selectedAction, setSelectedAction] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [users, setUsers] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedApplications, setSelectedApplications] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [paginationData, setPaginationData] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(100);
  const [totalItems, setTotalItems] = useState(0);
  const [page, setPage] = useState(1);
  const [filterStatus, setFilterStatus] = useState("");
  const [filterModalOpen, setFilterModalOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    fetchApplications();
  }, [currentPage, itemsPerPage]);

  const fetchApplications = () => {
    setLoading(true);
    fetch(
      `${apiurl}/api/application/past-joining?page=${currentPage}&limit=${itemsPerPage}`
    )
      .then((res) => res.json())
      .then((data) => {
        setApplications(data.applications);
        setTotalItems(data.pagination?.totalItems || 0);
        setTotalPages(data.totalPages);
        setLoading(false);
        setPaginationData(data?.pagination);
        setSelectAll(false);
        setSelectedApplications([]);
      })
      .catch((err) => {
        console.error("Error fetching applications:", err);
        setLoading(false);
      });
  };


  const filteredApps = applications.filter((app) => {
    const nameMatch =
      app?.candidateSnapshot?.firstName
        ?.toLowerCase()
        .includes(search.toLowerCase()) ||
      app?.candidateSnapshot?.lastName
        ?.toLowerCase()
        .includes(search.toLowerCase());
    const emailMatch = app?.candidateSnapshot?.email
      ?.toLowerCase()
      .includes(search.toLowerCase());
    return nameMatch || emailMatch;
  });

  const listVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (index) => ({
      opacity: 1,
      y: 0,
      transition: { delay: index * 0.1, duration: 0.1 },
    }),
  };

  const handleLimitChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setPage(1);
  };

  useEffect(() => {
    setTotalPages(Math.ceil(totalItems / itemsPerPage) || 1);
  }, [totalItems, itemsPerPage]);

  const handleCheckboxChange = (appId) => {
    setSelectedApplications((prevSelected) =>
      prevSelected.includes(appId)
        ? prevSelected.filter((id) => id !== appId)
        : [...prevSelected, appId]
    );
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedApplications([]);
    } else {
      setSelectedApplications(applications.map((app) => app._id));
    }
    setSelectAll(!selectAll);
  };

  console.log("selectedApplications", selectedApplications);

  const exportToExcel = () => {
    let dataToExport = applications;

    if (selectedApplications.length > 0) {
      dataToExport = dataToExport.filter((emp) =>
        selectedApplications.includes(emp._id)
      );
    }

    if (dataToExport.length === 0) {
      alert("No employee data found for export.");
      return;
    }

    const  uppercase = (value) => {
      return typeof value === "string" ? value.toUpperCase() : value;
    };

    const capitalize = (value) => {
      return typeof value === "string"
        ? value
            .split(/(\s+)/) // split by spaces, keeping the separators
            .map(word =>
              word.trim() ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : word
            )
            .join("")
        : value;
    };
    
    

    const normalizeId = (rawId) => {
      if (!rawId) return "";
      const match = rawId.toUpperCase().match(/(SUW)[\s\-]?(\d+)/);
      return match ? `${match[1]}${match[2]}` : rawId.toUpperCase();
    };


    const flattenEmployeeData = (emp, index) => {
      const refType = emp.referenceDetails?.referenceType;
      let referenceName = "";
      let referenceId = "";

      if (refType === "employee") {
        referenceName = `EMP-${emp.referenceDetails.employeeName || ""}`;
        // referenceId = `SUW-${emp.referenceDetails.employeeId || ""}`;
        referenceId = normalizeId(emp.referenceDetails.employeeId || "");
      } else if (refType === "recruiter") {
        referenceName = `HR-${emp.referenceDetails.recruiterName || ""}`;
        referenceId = `SUW-${emp.referenceDetails.recruiterId || ""}`;
      } else if (refType === "consultancy") {
        referenceName = `${emp.referenceDetails.consultancyReference || ""}`;
        referenceId = "Consultancy";
      } else if (refType === "other") {
        referenceName = `OTHER-${emp.referenceDetails.otherReference || ""}`;
        referenceId = "N/A";
      } else if (refType === "walkin") {
        referenceName = `WALKIN`;
        referenceId = "N/A";
      } else {
        referenceName = "N/A";
        referenceId = "N/A";
      }

      const interviewDate = emp.screeningDetails?.date;
      const joiningDate = emp.offerDetails?.joiningDate;
      const joiningMailSent = emp.offerDetails?.joiningMail?.status;
      const joiningMailDate = emp.offerDetails?.joiningMail?.date;

      const offeredCTC = emp.offerDetails?.offeredCTC
        ? `${emp.offerDetails.offeredCTC.toFixed(2)} LPA / ${(
            emp.offerDetails.offeredCTC / 12
          ).toFixed(2)} MONTHLY`
        : "";

      return {
        SNO: index + 1,
        ID: capitalize(emp.id || ""),
        NAME: capitalize(
          `${emp.candidateSnapshot.firstName} ${emp.candidateSnapshot.lastName}` ||
            ""
        ),
        DESIGNATION: capitalize(emp.positionTitle || ""),
        DEPARTMENT: capitalize(emp.department || ""),
        "REFERENCE NAME": capitalize(referenceName),
        "REFERENCE ID": uppercase(referenceId),
        "CONTACT NO": capitalize(emp.candidateSnapshot.phone || ""),
        EMAIL: capitalize(emp.candidateSnapshot.email || ""),
        MONTH: interviewDate
          ? new Date(interviewDate)
              .toLocaleString("default", { month: "long" })
              .toUpperCase()
          : "",
        YEAR: interviewDate ? new Date(interviewDate).getFullYear() : "",
        "INTERVIEW DATE": interviewDate
          ? new Date(interviewDate).toLocaleDateString().toUpperCase()
          : "",
        "INTERVIEW STATUS": capitalize(emp.applicationStatus || ""),
        "INTERVIEW REMARKS": capitalize(emp.screeningDetails?.feedback || ""),
        "OFFERED SALARY": offeredCTC,
        "JOINING MAIL STATUS": joiningMailSent ? "SENT" : "NOT SENT",
        "JOINING MAIL DATE": joiningMailDate
          ? new Date(joiningMailDate).toLocaleDateString().toUpperCase()
          : "",
        "DATE OF JOINING": joiningDate
          ? new Date(joiningDate).toLocaleDateString().toUpperCase()
          : "",
      };
    };

    const formattedData = dataToExport.map(flattenEmployeeData);

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "APPLICATIONS");

    const fileName = `APPLICATIONS_${
      new Date().toISOString().split("T")[0]
    }.xlsx`;
    XLSX.writeFile(workbook, fileName);
  };


  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>
        <div className="p-2 bg-gray-100 ">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6 gap-3">
            <div className="flex items-center gap-2 w-full md:w-1/3">
              <input
              type="text"
              placeholder="Search by name, email, id, or aadhar"
              className="p-2 border rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            </div>
            <div className="flex flex-wrap gap-2 justify-start md:justify-end items-center w-full md:w-auto">

            <p className="bg-blue-100 text-blue-800 text-xs font-medium me-2 px-2.5 py-2 rounded-sm dark:bg-blue-900 dark:text-blue-300">{applications?.length}
            </p>
              <button
                className={`flex items-center gap-2 px-4 py-2 rounded-lg text-white bg-green-500 hover:bg-green-600 transition ${
                  selectedApplications.length === 0
                    ? "opacity-50 cursor-not-allowed"
                    : ""
                }`}
                onClick={exportToExcel}
                disabled={selectedApplications.length === 0}
              >
                <FaFileExcel /> Download Excel
              </button>

              <select
                className="p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={itemsPerPage}
                onChange={handleLimitChange}
              >
                <option value="100">100</option>
                <option value="200">200</option>
                <option value="500">500</option>
                <option value="500">500</option>
                <option value="1000">1000</option>
                <option value="2000">2000</option>
                <option value="3000">3000</option>
                <option value="5000">5000</option>
              </select>
            </div>
          </div>

          {loading ? (
            <SuwasthiLoader />
          ) : (
            <div className="bg-white shadow-md rounded-lg p-4 overflow-x-auto">
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="p-3">
                      <input
                        type="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAll}
                      />
                    </th>
                    <th className="p-3 text-left">Application ID</th>
                    <th className="p-3 text-left">Name</th>
                    <th className="p-3 text-left">Email</th>
                    <th className="p-3 text-left">Status</th>
                    <th className="p-3 text-left">Canceled Mail</th>
                    <th className="p-3 text-left">Actions</th>
                  </tr>
                </thead>
                <tbody>


                  {filteredApps.map((app, index) => (
                    <motion.tr
                      key={app._id}
                      className={`border-b ${
                        !app.isRead ? "bg-yellow-100" : ""
                      }`}
                      variants={listVariants}
                      initial="hidden"
                      animate="visible"
                      custom={index}
                    >
                      <td className="p-3">
                        <input
                          type="checkbox"
                          checked={selectedApplications.includes(app._id)}
                          onChange={() => handleCheckboxChange(app._id)}
                        />
                      </td>

                      <td className="p-3 flex items-center gap-2">
                        {(() => {
                          const createdDate = new Date(app.createdAt);
                          const today = new Date();

                          const isToday =
                            createdDate.getDate() === today.getDate() &&
                            createdDate.getMonth() === today.getMonth() &&
                            createdDate.getFullYear() === today.getFullYear();

                          return isToday ? (
                            <motion.span
                              className="bg-green-500 text-white px-2 py-1 text-xs rounded"
                              initial={{ scale: 0 }}
                              animate={{ scale: 1 }}
                              transition={{ type: "spring", stiffness: 200 }}
                            >
                              New
                            </motion.span>
                          ) : null;
                        })()}
                        {app?.id}
                      </td>
                      <td className="p-3">
                        {app?.candidateSnapshot?.firstName}{" "}
                        {app?.candidateSnapshot?.lastName}
                      </td>
                      <td className="p-3">{app.candidateSnapshot?.email}</td>
                      <td className="p-3">{app.applicationStatus}</td>
                      <td className="p-3 text-center">
                        <span
                          className={`px-2 py-1 text-xs font-semibold rounded-full ${
                            app?.offerDetails?.canceledMail?.status === true
                              ? "bg-green-100 text-green-700"
                              :   app?.offerDetails?.canceledMail?.status === false
                              ? "bg-red-100 text-red-700"
                              : "bg-yellow-100 text-yellow-700"
                          }`}
                        >
                          {app?.offerDetails?.canceledMail?.status || "NA"}
                        </span>
                      </td>
                      <td className="p-3 flex gap-2">
                        <Link
                          className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                          whileHover={{ scale: 1.1 }}
                          to={`/applications/${app._id}/manage`}
                        >
                          Manage
                        </Link>
                      </td>
                    </motion.tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
        <Pagination
          currentPage={currentPage}
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </Container>
    </Layout>
  );
};

export default PastJoining;